(ns manage.feed-lookup-table.form
  (:require [common.form.core :as form]))

(form/register-form {:namespace :form.feed-lookup})

(def use-bind-control (partial form/use-bind-control :form.feed-lookup))

(def separator-options
  [{:label ". (period)"
    :value "."}
   {:label ", (comma)"
    :value ","}
   {:label "; (semicolon)"
    :value ";"}
   {:label "(whitespace)"
    :value " "}])

(def postcode-options
  [{:label "UK sector (e.g. SW16 6)"
    :value "postcode-uk-sector"}
   {:label "UK district (e.g. SW1)"
    :value "postcode-uk-district"}
   {:label "UK subdistrict (e.g. SW16)"
    :value "postcode-uk-subdistrict"}
   {:label "CA district (e.g. M)"
    :value "postcode-ca-district"}
   {:label "CA FSA (e.g. M4B)"
    :value "postcode-ca-fsa"}
   {:label "CA FSA + 1st digit LDU (e.g. M4B 1)"
    :value "postcode-ca-fsa-block"}
   {:label "IN Postcode (e.g. 400060)"
    :value "postcode-ind"}
   {:label "NL region (e.g. 10)"
    :value "postcode-nl-region"}
   {:label "NL subregion (e.g. 1000)"
    :value "postcode-nl-sub-region"}
   {:label "DE region (e.g. 10)"
    :value "postcode-de-region"}
   {:label "DE postcode (e.g. 10115)"
    :value "postcode-de-postcode"}])
